// src/tenantAdmin/components/RunStatusPill.jsx
// Run status pill (Brian UI). Terminal statuses get their own colour; every
// non-terminal (pipeline still in flight) collapses to "In bozza" per the design.
import React from 'react';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

export default function RunStatusPill({ status }) {
  const s = (status || '').toLowerCase();
  let cfg;
  if (s === 'completed' || s === 'approved') {
    cfg = { label: 'Completato', fg: SEMANTIC.verde.fg, bg: SEMANTIC.verde.bg };
  } else if (s === 'failed') {
    cfg = { label: 'Fallita', fg: SEMANTIC.errore.fg, bg: SEMANTIC.errore.bg };
  } else if (s === 'cancelled') {
    cfg = { label: 'Annullata', fg: COLORS.textSecondary, bg: COLORS.field };
  } else {
    cfg = { label: 'In bozza', fg: SEMANTIC.viola.fg, bg: SEMANTIC.viola.bg };
  }
  return (
    <span style={{
      display: 'inline-block', padding: '4px 12px', borderRadius: RADII.pill,
      fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap',
      background: cfg.bg, color: cfg.fg, fontFamily: FONT_SANS,
    }}>
      {cfg.label}
    </span>
  );
}
